import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de8172ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderCard" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex items-center justify-center"
}
const _hoisted_3 = { class: "StatusesTable" }
const _hoisted_4 = {
  key: 1,
  class: "flex items-center flex-wrap"
}
const _hoisted_5 = { class: "OrderCard__header" }
const _hoisted_6 = { class: "header__sector" }
const _hoisted_7 = { class: "OrderCard__container" }
const _hoisted_8 = { class: "container__text" }
const _hoisted_9 = { class: "container__text" }
const _hoisted_10 = { class: "container__text" }
const _hoisted_11 = { class: "container__text" }
const _hoisted_12 = { class: "container__text mt-2" }
const _hoisted_13 = { class: "container__text" }
const _hoisted_14 = { class: "container__text mt-2" }
const _hoisted_15 = { class: "container__text" }
const _hoisted_16 = { class: "container__text" }
const _hoisted_17 = { class: "container__text" }
const _hoisted_18 = { class: "container__text" }
const _hoisted_19 = { class: "container__text mt-2" }
const _hoisted_20 = { class: "container__text" }
const _hoisted_21 = { class: "OrderCard__actions" }
const _hoisted_22 = { class: "OrderCard__actions" }
const _hoisted_23 = { class: "mt-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-3" }, "График работы компании", -1))
const _hoisted_25 = { class: "mt-3 grid grid-cols-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-2" }, "Забор", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-2" }, "Доставка", -1))
const _hoisted_28 = {
  key: 0,
  class: "container__text text-gray-400 text-sm"
}
const _hoisted_29 = { class: "OrderCard__takes" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-3" }, "Накладные", -1))
const _hoisted_31 = { class: "flex justify-between w-full mb-3" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 2,
  class: "text-gray-400 flex justify-center items-center flex-col select-none"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Выберите заказ в списке, для детального просмотра", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mt-3" }, null, -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_invoice_status_row = _resolveComponent("invoice-status-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_order_card_statuses_line = _resolveComponent("order-card-statuses-line")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_shortcoming_files = _resolveComponent("shortcoming-files")!
  const _component_cost_files = _resolveComponent("cost-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_loader, { class: "primary" })
        ]))
      : (_ctx.state.take_order)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isLoModal)
              ? (_openBlock(), _createBlock(_component_new_modal, {
                  key: 0,
                  title: "Статусы ЛО",
                  onCancel: _ctx.toggleLo,
                  "without-footer": ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_new_table, {
                        columns: _ctx.COLUMNS,
                        rows: _ctx.state.take_order.waitListStatusesHistory
                      }, {
                        td: _withCtx(({ column, row }) => [
                          _createVNode(_component_invoice_status_row, {
                            column: column,
                            row: row
                          }, null, 8, ["column", "row"])
                        ]),
                        _: 1
                      }, 8, ["columns", "rows"])
                    ])
                  ]),
                  _: 1
                }, 8, ["onCancel"]))
              : _createCommentVNode("", true),
            (_ctx.problems && _ctx.problems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.problems, (problem, i) => {
                    return (_openBlock(), _createBlock(_component_cheap, {
                      class: "small mr-2 mb-2 red",
                      key: `pb-${i}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(problem), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.take_order.waitList && _ctx.state.take_order.waitList.comment)
              ? (_openBlock(), _createBlock(_component_cheap, {
                  key: 2,
                  class: "small mb-2 red",
                  style: { width: 'fit-content' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.state.take_order.waitList.comment), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                (_ctx.state.take_order.sender && _ctx.state.take_order.sender.sector)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.state.take_order.sender.sector.name), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Сектор не указан ")
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, "Компания: " + _toDisplayString(_ctx.state.take_order.companyName), 1),
              _createElementVNode("p", _hoisted_9, [
                (_ctx.state.take_order.sender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Адрес: " + _toDisplayString(_ctx.state.take_order.sender.fullAddress), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Адрес: - ")
                    ], 64))
              ]),
              _createElementVNode("p", _hoisted_10, "Номер 1С: " + _toDisplayString(_ctx.state.take_order.number), 1),
              _createElementVNode("p", _hoisted_11, " Менеджер: " + _toDisplayString(_ctx.state.take_order.companyManager || '-'), 1),
              _createElementVNode("p", _hoisted_12, [
                (_ctx.state.take_order.sender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Контактное лицо: " + _toDisplayString(_ctx.state.take_order.sender.fullName), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Контактное лицо: - ")
                    ], 64))
              ]),
              _createElementVNode("p", _hoisted_13, [
                (_ctx.state.take_order.sender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Контактный телефон: " + _toDisplayString(_ctx.state.take_order.sender.phone), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Контактный телефон: - ")
                    ], 64))
              ]),
              _createElementVNode("p", _hoisted_14, [
                (_ctx.state.take_order.periodTitle && _ctx.state.take_order.periodTitle.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Период забора: "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.take_order.periodTitle, (period_title, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `title-${i}`
                        }, [
                          (i !== 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(", ")
                              ], 64))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(period_title), 1)
                        ], 64))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Период забора: Нет данных ")
                    ], 64))
              ]),
              _createElementVNode("p", _hoisted_15, [
                (_ctx.state.take_order.sender)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Комментарий отправителя: " + _toDisplayString(_ctx.state.take_order.sender.comment || 'Нет данных'), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Комментарий отправителя: - ")
                    ], 64))
              ]),
              _createElementVNode("p", _hoisted_16, " Общее количество мест: " + _toDisplayString(_ctx.state.take_order.totalPlaces), 1),
              _createElementVNode("p", _hoisted_17, " Общий физический вес: " + _toDisplayString(_ctx.state.take_order.totalWeight), 1),
              _createElementVNode("p", _hoisted_18, " Доп. услуги при заборе: " + _toDisplayString(_ctx.getAdditionalInfo || 'Нет данных'), 1),
              (Boolean(_ctx.state.take_order.courier))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", _hoisted_19, " Курьер: " + _toDisplayString(_ctx.state.take_order.courier.fullName), 1),
                    _createElementVNode("p", _hoisted_20, " Телефон курьера: " + _toDisplayString(_ctx.state.take_order.courier.phoneNumber), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _ctx.emitAssignOrder
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Назначить ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _ctx.emitChangeDate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перенести забор ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _ctx.emitWaitList
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить в ЛО ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _ctx.emitShortcoming
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Загрузить Акт ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitPayment(1))),
                disabled: _ctx.hasRoadFiles
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить Платный проезд ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_the_button, {
                class: "text primary small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitPayment(2))),
                disabled: _ctx.hasParkingFiles
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить Платную парковку ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            (
                    _ctx.state.take_order.waitListStatusesHistory &&
                    _ctx.state.take_order.waitListStatusesHistory.length
                )
              ? (_openBlock(), _createBlock(_component_new_button, {
                  key: 3,
                  class: "w-full primary small mt-3",
                  style: {"border-radius":"4px"},
                  onClick: _ctx.toggleLo
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Статусы ЛО ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _hoisted_26,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScheduleStrFinal(_ctx.schedule_take), (schedule) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "container__text text-sm",
                      key: schedule.id
                    }, _toDisplayString(schedule), 1))
                  }), 128))
                ]),
                _createElementVNode("div", null, [
                  _hoisted_27,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScheduleStrFinal(_ctx.schedule_delivery), (schedule) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "container__text text-sm",
                      key: schedule.id
                    }, _toDisplayString(schedule), 1))
                  }), 128))
                ])
              ]),
              (_ctx.state.company_schedule.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, " График работы компании не указан "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_order_card_statuses_line, {
              class: "mt-3",
              statuses: _ctx.state.take_order.statusHistory
            }, null, 8, ["statuses"]),
            (_ctx.state.take_order.states && _ctx.state.take_order.states.length > 0)
              ? (_openBlock(), _createBlock(_component_cheap, {
                  key: 4,
                  class: "primary small mt-2"
                }, {
                  default: _withCtx(() => [
                    (Boolean(_ctx.state.take_order.courier))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.state.take_order.courier.fullName), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" (" + _toDisplayString(_ctx.state.take_order.states[_ctx.state.take_order.states.length - 1].title) + " " + _toDisplayString(_ctx.state.take_order.states[_ctx.state.take_order.states.length - 1].date) + ") ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.state.take_order.waitList && _ctx.state.take_order.waitList.status)
              ? (_openBlock(), _createBlock(_component_cheap, {
                  key: 5,
                  class: _normalizeClass(_ctx.getWaitListClass)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getWaitListStatus), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.take_order.takes, (take) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `take-${take.takeId}`,
                  class: "invoice"
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", null, "Накладная (ID): " + _toDisplayString(take.invoiceId), 1),
                    (take.statusId)
                      ? (_openBlock(), _createBlock(_component_cheap, {
                          key: 0,
                          class: _normalizeClass(["small mr-2 w-max", {
                                red: take.statusId === 1,
                                primary: take.statusId === 2,
                                yellow: take.statusId === 3,
                                green: take.statusId === 4,
                            }])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(take.statusName), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Номер накладной: "),
                    _createVNode(_component_router_link, {
                      class: "text-blue-500",
                      to: `/invoice/${take.invoiceId}`,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(take.invoiceNumber), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" Направление: "),
                    (_ctx.state.take_order.sender)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.state.take_order.sender.cityName) + " - " + _toDisplayString(take.receiverCity), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
                  ]),
                  (take.sizeType)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, "Коробка: " + _toDisplayString(take.sizeType || '-'), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createVNode(_component_shortcoming_files, {
              class: "mt-3",
              "order-id": _ctx.state.take_order.orderId
            }, null, 8, ["order-id"]),
            _createVNode(_component_cost_files, {
              class: "mt-3",
              title: "ПЛАТНАЯ ПАРКОВКА/ПРОЕЗД (ЗАБОРЫ)",
              "order-id": _ctx.state.take_order.orderId
            }, null, 8, ["order-id"])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
  ]))
}